/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Component, Input, OnInit } from "@angular/core";
import { CodeSnippetComponent } from "typedb-cloud-framework";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { LoadingTip, loadingTips2, loadingTips3 } from "./loading-tips";
import { ParsedVersion } from "../../shared";

@Component({
    selector: "tp-cluster-loading-tips",
    templateUrl: "./cluster-loading-tips.component.html",
    styleUrls: ["./cluster-loading-tips.component.scss"],
    imports: [
        MatTooltipModule, MatButtonModule, MatSelectModule, CodeSnippetComponent, MatStepperModule,
    ]
})
export class ClusterLoadingTipsComponent implements OnInit {
    @Input({ required: true }) clusterVersion!: ParsedVersion;
    loadingTips: LoadingTip[] = [];

    loadingTipIndex = 0;
    nextTip(el: HTMLElement) {
        this.loadingTipIndex = (this.loadingTipIndex + 1) % this.loadingTips.length;
        setTimeout(() => el.scrollIntoView());
    }
    prevTip(el: HTMLElement) {
        this.loadingTipIndex = (this.loadingTipIndex - 1 + this.loadingTips.length) % this.loadingTips.length;
        setTimeout(() => el.scrollIntoView());
    }

    ngOnInit() {
        if (this.clusterVersion.major <= 2) this.loadingTips = loadingTips2.sort(() => Math.random() - Math.random());
        else this.loadingTips = loadingTips3.sort(() => Math.random() - Math.random());
    }
}
